import React, { useState } from 'react'
import { initials } from '../Utils/text'

/* A source's logo in a circle, or its initials when there's no logo. */
export function SourceAvatar({ source, size = 20, className = '' }) {
  const [failed, setFailed] = useState(false)
  const style = { width: size, height: size, fontSize: Math.max(8, Math.round(size * 0.4)) }
  if (source?.logoUrl && !failed) {
    return (
      <img
        className={`source-avatar ${className}`}
        style={style}
        src={source.logoUrl}
        alt=""
        loading="lazy"
        referrerPolicy="no-referrer"
        onError={() => setFailed(true)}
      />
    )
  }
  return (
    <span className={`source-avatar source-initials ${className}`} style={style} aria-hidden="true">
      {initials(source?.name)}
    </span>
  )
}

/* Up to three overlapping logos (the "N izvora" button, the pill). */
export function SourceStack({ sources = [], size = 20 }) {
  return (
    <span className="source-stack" aria-hidden="true">
      {sources.slice(0, 3).map((s) => (
        <SourceAvatar key={s.slug || s.name} source={s} size={size} />
      ))}
    </span>
  )
}
